import React, {useState} from "react";
import {useTranslation} from "react-i18next";
// local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {Modal} from "components/Modal";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {IconNotificationCircle, IconDocumentPen} from "components/icons";
import {color} from "constants/color.consts";

export const SignContractSignModal = ({
  file,
  lastSignature,
  organizationName,
  onAccept,
  onClose,
}) => {
  const {t} = useTranslation();

  const [finalizeSignatures, setFinalizeSignatures] = useState(false);
  const [cantAddMoreSignatures, setCantAddMoreSignatures] = useState(false);

  const fileLinkProps = {
    href: file?.url || file?.File?.url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "blue cpointer fz-12",
  };

  return (
    <Modal
      titleIcon={<IconNotificationCircle color={color.orange} addClass="mr-2" />}
      titleText="SIGN_CONTRACT_SIGN_MODAL_SIGN_TITLE"
      boldTitle
      noCloseButton
      noCloseOnEsc
      noCenterContent
      width="450"
      rounded
      whiteTitle
      onClose={onClose}
    >
      <div className="pb-8 pl-8 pr-8">
        <div className="df-row-center pa-2 border-form">
          <IconDocumentPen color={color.link} addClass="mr-2" />
          <a {...fileLinkProps}>{file?.name}</a>
        </div>
        <p className="fz-16 mt-4 mb-4">
          {t("SIGN_CONTRACT_SIGN_MODAL_SIGN_DESCRIPTION")}
        </p>
        {lastSignature && (
          <CustomRadioSwitch
            label={t("SIGN_CONTRACT_SIGN_MODAL_SIGN_TOGGLE_01")}
            checked={finalizeSignatures}
            small
            largeText
            addWrapperClass="mb-2 mt-4"
            isActive={setFinalizeSignatures}
          />
        )}
        {lastSignature && (
          <CustomRadioSwitch
            label={t("SIGN_CONTRACT_SIGN_MODAL_SIGN_TOGGLE_02").format(organizationName)}
            small
            largeText
            checked={cantAddMoreSignatures}
            isActive={setCantAddMoreSignatures}
          />
        )}
        <div className="df mt-8">
          <ButtonTransparent
            name="CANCEL"
            medium
            onClick={onClose}
            color="red"
            addClass="mla"
          />
          <ButtonTransparent
            name="SIGN_CONTRACT_ACTION_BUTTON_SIGN_PROCEED"
            medium
            nowrap
            nonTransparent
            disabled={lastSignature && !(finalizeSignatures && cantAddMoreSignatures)}
            onClick={onAccept}
            addClass="ml-4"
          />
        </div>
      </div>
    </Modal>
  );
};
